// removed by extract-text-webpack-plugin
module.exports = {"fund__section":"fund__section__jtAwy","fund__card":"fund__card__2NJXd","fund__table":"fund__table__3Yu8a"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/fundsection.scss
// module id = 1265
// module chunks = 68